import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

import "../src/styles/main.scss";
import App from "./App";
import CustomSWR from "./config/swr";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <CustomSWR>
      <App />
    </CustomSWR>
  </Router>
);
